export default __webpack_public_path__ + "media/consorcio-img.jpg";